import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from "vue";
import { deleteDocumentsApi, getDocumentsApi, postDocumentsApi } from "@Shared/utils/ajax";
export const getDocumentClassifications = applicationId => {
  const endpoint = `/application/${applicationId}`;
  return getDocumentsApi({}, endpoint);
};
export const downloadDocument = (documentId, fileName, applicationId) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApi({
    fileName,
    applicationId
  }, endpoint);
};
export const downloadDocumentNoClient = (documentId, fileName) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApi({
    fileName
  }, endpoint);
};
export const getSignedURL = (fileName, clientUsername, documentRequestId) => {
  const endpoint = "/signed-s3-url";
  return getDocumentsApi({
    fileName,
    documentRequestId
  }, endpoint);
};
export const createSignedUrls = (filesInfo, applicationId, documentRequestId) => {
  const endpoint = `/application/${applicationId}/signed-s3-url`;
  const payload = {
    documentRequestId
  };
  return postDocumentsApi(_objectSpread(_objectSpread({}, payload), {}, {
    filesInfo
  }), endpoint);
};
export const markUploadCompleted = async (applicationId, classificationType, documentDescription, documentS3Key, documentRequestId, encrypted = false) => {
  const session = Vue.auth.session.get();
  const brokerageId = session.brokerageDetails.tiedBrokerages[0].brokerageId;
  const endpoint = `/${documentS3Key}`;
  return postDocumentsApi({
    classificationType,
    applicationId: applicationId,
    brokerageId,
    documentOptions: {
      documentRequestId,
      documentDescription
    },
    encrypted
  }, endpoint);
};
export const sendComment = async (documentId, comment) => {
  const endpoint = `/${documentId}/comment`;
  return postDocumentsApi(comment, endpoint);
};
export const updateDocumentStatus = async (applicationId, clientUsername, requestId, documentNumber, status) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/${requestId}/document/${documentNumber}/${status}`;
  return postDocumentsApi({}, endpoint);
};
export const markDocumentRequestUploadCompleted = async (documentRequestId, documentS3Key) => {
  const endpoint = `/request-list/classification/${documentRequestId}`;
  return postDocumentsApi({
    documentS3Key
  }, endpoint);
};
export const deleteDocument = async documentId => {
  const endpoint = `/${documentId}`;
  return deleteDocumentsApi(endpoint);
};